import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { redFunnelAPI } from '../api/api'
import { findMaintenanceAlert } from '../utilities/siteAlerts'
import LoadingSpinner from './LoadingSpinner/LoadingSpinner'
import MaintenanceMode from './MaintenanceMode'

/**
 * Checks the site alert feed and shows the maintenance page instead of whatever it
 * wraps while a maintenance alert is live.
 *
 * Two deliberate choices:
 * - It fails OPEN. A feed that errors, times out or is unreachable leaves booking
 *   working, because taking the site down over a failed content request is worse
 *   than missing a maintenance notice.
 * - It holds the spinner until the check resolves, so the booking form never
 *   flashes up before being replaced. getSiteAlerts caps that wait at 5s.
 */
const MaintenanceGate = ({ children }) => {
  const [{ isChecking, alert, serviceStatusContent }, setState] = useState({
    isChecking: true,
    alert: null,
    serviceStatusContent: '',
  })

  useEffect(() => {
    let isCurrent = true
    const settle = (nextAlert, nextServiceStatus = '') => {
      if (isCurrent)
        setState({
          isChecking: false,
          alert: nextAlert,
          serviceStatusContent: nextServiceStatus,
        })
    }
    redFunnelAPI
      .getSiteAlerts()
      .then(({ alerts, serviceStatusContent: status }) =>
        settle(findMaintenanceAlert(alerts), status),
      )
      .catch(() => settle(null))
    return () => {
      isCurrent = false
    }
  }, [])

  if (isChecking) {
    return (
      <div className="pt-10 flex items-center flex-1">
        <LoadingSpinner />
      </div>
    )
  }

  if (alert) {
    return (
      <MaintenanceMode
        alert={alert}
        serviceStatusContent={serviceStatusContent}
      />
    )
  }

  return children
}

MaintenanceGate.propTypes = {
  children: PropTypes.node.isRequired,
}

export default MaintenanceGate
